import React, { useEffect, useState } from 'react'
import filesubnmitted from "./folder-access.ico"
// import Icon from '../icons';
import { useAgencyInfo } from '../../../../../context/agency';
import "./style.css"
import { useAssistantWebsiteScraper } from 'queries/assistants';
import { useUploadAssistantWebsite } from 'queries/chat';

function Index({ classname, refreshchat, assistant_id, setSelectedIndex, handlerRefresh }) {
  const [agency] = useAgencyInfo();
  const { fetchWebsiteUrl, getScrapeStatus, getScrapedUrls } = useAssistantWebsiteScraper();
  const [alertModel, setAlertModel] = useState(false);
  const [successModel, setSuccessModel] = useState(false);
  const [websiteURL, setWebsiteURL] = useState('');
  const [addingWebsite, setAddingWebsite] = useState(false);
  const [loaderaddingWebsite, setloaderaddingWebsite] = useState(false);
  const [urlErrorMessage, setUrlErrorMessage] = useState(''); // For URL validation message
  const [assistantErrorMessage, setAssistantErrorMessage] = useState('');
  const [WebURlResponse, setWebURlResponse] = useState([]);
  const [selectedUrls, setSelectedUrls] = useState([]);
  const [inprogress, setinprogress] = useState(false);
  const [jobId, setjobId] = useState();
  const [totalURLs, setTotalURLs] = useState();
  const [inProgressURLs, setInProgressURLs] = useState();

  const handleCheckboxChange = (url) => {
    setSelectedUrls((prevSelectedUrls) =>
      prevSelectedUrls.includes(url)
        ? prevSelectedUrls.filter((selectedUrl) => selectedUrl !== url)
        : [...prevSelectedUrls, url]
    );
  };

  const handleSelectAllChange = (isChecked) => {
    if (isChecked) {
      setSelectedUrls(WebURlResponse); // Select all URLs
    } else {
      setSelectedUrls([]); // Deselect all URLs
    }
  };

  const scrapeWebsite = async (e) => {
    setUrlErrorMessage('')
    try {
      setinprogress(true);
      setloaderaddingWebsite(true);

      // Basic URL validation regex
      const urlRegex = /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/;

      // Validate website URL
      if (!websiteURL || !urlRegex.test(websiteURL)) {
        setUrlErrorMessage('Please enter a valid website URL.');
        setloaderaddingWebsite(false);
        setWebURlResponse([]);
        return;
      }

      const payload = { url: websiteURL, profileId: agency._id };


      const { response } = await fetchWebsiteUrl(payload);
      console.log('responseresponseresponseresponse', response)
      if (response?.jobId) {
        const jobId = response.jobId;
        setjobId(jobId);

        // Start polling to check job status
        pollJobStatus(jobId);
      } else {
        setUrlErrorMessage('Failed to initiate scraping. Please try again.');
        setloaderaddingWebsite(false);
        setinprogress(false);
      }
    } catch (error) {
      setloaderaddingWebsite(false);
      setinprogress(false);
      console.error('Error initiating scraping:', error);
    }
  };

  const pollJobStatus = (jobId) => {
    const pollInterval = 5000; // Poll every 5 seconds
    const maxAttempts = 20; // Max attempts to avoid infinite polling
    let attempt = 0;

    const interval = setInterval(async () => {
      attempt++;

      try {
        const { response: statusResponse } = await getScrapeStatus(jobId);
        setTotalURLs(statusResponse?.data?.total_urls)
        setInProgressURLs(statusResponse?.data?.stats?.success)
        if (statusResponse?.status === 'completed') {
          clearInterval(interval); // Stop polling once job is complete

          // Fetch URLs once the job is complete
          fetchScrapedUrls(jobId);
        } else if (statusResponse?.status === 'failed' || attempt >= maxAttempts) {
          clearInterval(interval); // Stop polling if job fails or max attempts reached
          setUrlErrorMessage('Failed to complete scraping. Please try again.');
          setloaderaddingWebsite(false);
          setinprogress(false);
        }
      } catch (error) {
        console.error('Error checking job status:', error);
        clearInterval(interval);
        setUrlErrorMessage('Error while checking status. Please try again.');
        setloaderaddingWebsite(false);
        setinprogress(false);
      }
    }, pollInterval);
  };

  const fetchScrapedUrls = async (jobId) => {
    try {
      const { response: urlsResponse } = await getScrapedUrls(agency._id, jobId);

      if (urlsResponse?.data?.length > 0) {
        setWebURlResponse(urlsResponse.data);
        setUrlErrorMessage('');
      } else {
        setUrlErrorMessage('No URLs found. Please try again.');
      }

      setloaderaddingWebsite(false);
      setinprogress(false);
    } catch (error) {
      console.error('Error fetching scraped URLs:', error);
      setUrlErrorMessage('Failed to fetch URLs. Please try again.');
      setloaderaddingWebsite(false);
      setinprogress(false);
    }
  };



  const { mutateAsync: uploadWebsite } = useUploadAssistantWebsite();

  const submitHandler = async () => {
    setUrlErrorMessage('');
    setAssistantErrorMessage('');
    setAddingWebsite(true);

    if (!selectedUrls || selectedUrls.length === 0) {
      setUrlErrorMessage('Please select at least one website before submitting.');
      setAddingWebsite(false);
      return;
    }


    const filteredUrls = selectedUrls.filter((url) => url != null);
    const payload = {
      assistant_ids: [assistant_id],
      profile_id: agency?._id,
      website: filteredUrls,
      username: 'Agency User',
      jobId: jobId,
    };


    const { response, error } = await uploadWebsite(payload);

    if (response) {
      setAlertModel(false);
      setAddingWebsite(false);
      setSuccessModel(true); // Show success modal
      handlerRefresh();
    } else {
      setAddingWebsite(false);
      setUrlErrorMessage(
        error?.message ||
        'There was an error uploading the website. Please try again.'
      );

    }

  };


  useEffect(() => {
    getSelection()

  }, [])

  return (
    <>
      {alertModel && (
        <div className="modal-zz" onClick={() => setAlertModel(false)}>
          <div className="modal-content-zz position-relative" onClick={(e) => e.stopPropagation()}>
            <p
              style={{
                position: "absolute",
                right: 5,
                width: "12px",
                top: "10px",
                height: "12px",
                cursor: "pointer",
              }}
              onClick={() => setAlertModel(false)}
            >
              X
            </p>

            {/* Website URL Input */}
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: 'center' }}>
              <p>Add your website URL</p>
              {inprogress && (
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  color: 'black', // Green color for text
                  fontWeight: 'bold',
                  fontSize: '15px',
                }}>

                  <div style={{
                    display: 'flex',
                    marginRight: '8px',
                  }}>
                    {[...Array(3)]?.map((_, index) => (
                      <div
                        key={index}
                        style={{
                          width: '8px',
                          height: '8px',
                          borderRadius: '50%',
                          backgroundColor: 'black',
                          margin: '0 2px',
                          opacity: 0,
                          animation: `fade 1.5s ease-in-out ${index * 0.3}s infinite`,
                        }}
                      />
                    ))}
                  </div>
                  <span style={{ padding: 0 }}>In Progress</span>
                  <style>
                    {`
                      @keyframes fade {
                        0%, 100% { opacity: 0; }
                        50% { opacity: 1; }
                      }
                    `}
                  </style>
                </div>
              )}
            </div>
            <div className='position-relative'>

              <input type="text" name='websiteurl' style={{ width: "100%" }} onChange={(e) => setWebsiteURL(e.target.value)} value={websiteURL} />
              <button className='inputbutton' disabled={loaderaddingWebsite} onClick={scrapeWebsite} style={{ border: "none", padding: "5px 8px" }}>
                {loaderaddingWebsite && (
                  <div class="spinner" style={{
                    width: '16px',
                    height: '16px',
                    display: "inline-block",
                    marginRight: "8px"
                  }}></div>)}
                Crawl
              </button>
            </div>
            {totalURLs && (
              <p style={{ textAlign: 'left' }}>{`${totalURLs}/${inProgressURLs}`} URLs Scraped</p>
            )}
            {WebURlResponse?.length > 0 && (
              <>
                <label style={{ display: "flex", alignItems: "center", margin: "0px 8px", width: "fit-content" }}>
                  <input
                    type="checkbox"
                    checked={selectedUrls.length === WebURlResponse.length}
                    onChange={(e) => handleSelectAllChange(e.target.checked)}
                  />
                  <span style={{ cursor: "pointer", background: "none" }}>Select All</span>
                </label>

                <ul className={`${!urlErrorMessage ? "lis-zain mt-4" : ""}`}>
                  {WebURlResponse?.map((url, index) => (
                    <span style={{ padding: "0px" }} key={index}>
                      <label style={{ display: "flex", width: "100%", justifyContent: "start" }}>
                        <input
                          type="checkbox"
                          checked={selectedUrls.includes(url)}
                          onChange={() => handleCheckboxChange(url)}
                        />
                        <span style={{ marginLeft: '6px', cursor: 'pointer', textAlign: 'left', padding: '10px 10px' }}>{url}</span>
                      </label>
                    </span>
                  ))}
                </ul>
              </>
            )}
            {/* URL Validation Message */}
            {urlErrorMessage && (
              <div style={{ color: 'red', marginTop: '5px' }}>{urlErrorMessage}</div>
            )}


            {/* Submit Button */}
            <button onClick={() => submitHandler(true)} aria-label="Send message" disabled={addingWebsite} className={classname} style={{
              backgroundColor: "#4D4D4D", color: "#fff",
              padding: "10px 20px",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
              marginTop: '20px',
              width: '100%'
            }} >
              <div className="hover-text">
                {addingWebsite && (
                  <div class="spinner" style={{
                    width: '16px',
                    height: '16px',
                    display: "inline-block",
                    marginRight: "8px"
                  }}></div>
                )}
                Add a URL
              </div>
            </button>
          </div>
        </div>
      )}
      {successModel && (
        <div className="modal-zz" onClick={() => setSuccessModel(false)}>
          <div className="modal-content-zz" onClick={(e) => e.stopPropagation()}>
            <p
              style={{
                position: "absolute",
                right: 5,
                width: "12px",
                top: "10px",
                height: "12px",
                cursor: "pointer",
              }}
              onClick={() => setSuccessModel(false)}
            >
              X
            </p>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
              <img src={filesubnmitted} width={"200px"} height={"200px"} />
              <h1 className="text-center">URL has been added!</h1>
            </div>
          </div>
        </div>
      )}
      <button onClick={() => { setAlertModel(true); setSelectedIndex(null) }} aria-label="Send message" style={{
        border: "none",
        background: "none",
        cursor: "pointer",
      }}>
        Add a Website URL
      </button>
    </>
  );
}

export default Index
